import { useQuery } from "@tanstack/react-query";
import { resolveUserProfileSource } from "./resolveUserProfileSource";

// Bridge 的 Abstraction：呼叫端只拿到統一的 User，不需要知道背後是哪個會員系統
export const useUserProfileQuery = (token: string | null) => {
  const source = resolveUserProfileSource();

  return useQuery({
    queryKey: ["userProfile", source.key, token],
    queryFn: () => source.fetchProfile(token || ""),
    enabled: !!token,
  });
};
